import React from 'react';

import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';

class ProductClass extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      imageStatus: false
    };

    //this.handleExpandClick = this.handleExpandClick.bind(this);
    
  }

  componentDidMount ( ) {
    if ( this.props ) {
      if ( this.props.isOn )
        this.setState ( { imageStatus: true } );
    }
  }

  componentDidUpdate ( prevProps ) {
    if ( prevProps !== this.props ) {
      if ( prevProps.doReset !== this.props.doReset && this.props.doReset === true ){
        //this.setState({doReset: this.props.doReset })
        this.setState ( { imageStatus: false } );
      } else {
        if ( this.props.isOn )
          this.setState ( { imageStatus: true } );
      }
    }
  }

  /* handleExpandClick ( ) {
    this.setState({ expanded: !this.state.expanded });
  } */

  sendToggleFilter ( name, type ) {
    let imageStatus = this.state.imageStatus;
    this.props.onClickFunction ( name, type );
    this.setState ( { imageStatus: !imageStatus } );
  }

  render() {
    let iref = null;
    let name = "";
    let image = null;
    let image_on = "";
    let image_off = "";
    let onClickFunction = null;

    if ( this.props ) {
      if ( this.props.iref ) iref = this.props.iref;
      if ( this.props.name ) name = this.props.name;
      if ( this.props.image ) image = this.props.image;
      if ( this.props.image_on ) image_on = this.props.image_on;
      if ( this.props.image_off ) image_off = this.props.image_off;
      if ( this.props.onClickFunction ) onClickFunction = this.props.onClickFunction;
    }

    return (
    
          <IconButton
            aria-label={name}
            title={name}
            onClick={ onClickFunction ? () => this.sendToggleFilter ( "classes", iref ) : "" } 
          >       
            <Avatar
              alt={name}
              src={image ? image : this.state.imageStatus ? image_on : image_off}
              sx={{ width: 32, height: 32 }}
            />
          </IconButton>      
          
   
    );

  }
}

export default ProductClass;